import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

function Home() {
  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
      <h1>Smart Pharmacy App</h1>
      <ul>
        <li><Link to="/medication-reminders">Medication Reminders</Link></li>
        <li><Link to="/drug-interaction-checker">Drug Interaction Checker</Link></li>
        <li><Link to="/prescription-refills">Prescription Refills</Link></li>
        <li><Link to="/telepharmacy">Telepharmacy</Link></li>
        <li><Link to="/medication-delivery">Medication Delivery</Link></li>
      </ul>
    </motion.div>
  );
}

export default Home;
